import { render, staticRenderFns } from "./ArticleLink.vue?vue&type=template&id=75aba9c8&"
import script from "./ArticleLink.vue?vue&type=script&lang=js&"
export * from "./ArticleLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports